import { createSlice } from "@reduxjs/toolkit";
import { DASHBOARD } from "../../../constant/reducer_names";

const initialState = {
  aidashboard: [] as any,
  dashfileUrl: null,
  moduletype: null,
  moduledateFilter: {} as any,
  clvNlpData: {} as any,
  clvNlpLycaData: {} as any,
  segmentationNlpData: {} as any,
  nlpSummary: {} as any,
  buyerNlpData: {} as any,
  churnPredictionNlp: {} as any,
  churnPlotNlp: {} as any,
  animation: {} as any,
  customerId: {} as any,
  loginDetails: {} as any,
  encryptedToken: null as any,
  isTyping: false,
  showAiChat: false,
  getNotifications: false
}
const DashboardSlice = createSlice({
  name: DASHBOARD,
  initialState,
  reducers: {
    setAiChat: (state, { payload }) => {
      state.aidashboard.push(payload);
    },
    clearAiChat: (state) => {
      state.aidashboard = [];
    },
    setTyping: (state, { payload }) => {
      state.isTyping = payload;
    },
    setFileUrl: (state, { payload }) => {
      state.dashfileUrl = payload;
    },
    setShowAiChat: (state, { payload }) => {
      state.showAiChat = payload;
    },
    setModuletype: (state, { payload }) => {
      state.moduletype = payload;
      // state.moduledateFilter = {}
    },
    setModuledateFilter: (state, { payload }) => {
      state.moduledateFilter = payload;
    },
    setClvNlpData: (state, { payload }) => {
      console.log('setClvNlpData=====', state, payload)
      state.clvNlpData = payload;
    },
    setClvNlpLycaData: (state, { payload }) => {
      console.log('setClvNlpData=====', state, payload)
      state.clvNlpLycaData = payload;
    },
    setSegmentationNlpData: (state, { payload }) => {
      state.segmentationNlpData = payload;
    },
    setSummary: (state, { payload }) => {
      console.log('setsummary-------', payload)
      state.nlpSummary = payload;
    },
    setBuyerPersonData: (state, { payload }) => {
      console.log('setBuyerPersonData', payload)
      state.buyerNlpData = payload;
    },
    setChurnPrediction: (state, { payload }) => {
      console.log('setChurnPrediction', payload)
      state.churnPredictionNlp = payload;
    },
    setChurnPlotLyca: (state, { payload }) => {
      state.churnPlotNlp = payload;
    },
    setAnimation: (state, { payload }) => {
      state.animation = payload;
    },
    setCustomerId: (state, { payload }) => {
      state.customerId = payload;
    },
    setLoginDetails: (state, { payload }) => {
      state.loginDetails = payload;
    },
    setEncryptedToken: (state, { payload }) => {
      state.loginDetails = payload;
    },
    setCallNotification: (state, { payload }) => {
      state.getNotifications = payload;
    },
    reset: () => { },
  },
});
export const dashboardAction = DashboardSlice.actions;
export default DashboardSlice.reducer;